module.exports = __webpack_public_path__ + "static/media/close.ec1179d2.svg";